/**
 * 系统管理 Saga集合
 */
import operatingrule from './operatingrule/model';
import riderlevelset from './riderlevelset/model';
import shippingfeeset from './shippingfeeset/model';
import parameter from './parameter/model';
import versions from './versions/model';
import rate from './rate/model';
import feedbacktype from './feedbacktype/model';
import financialset from './financialset/model';
import riskcontrol from './riskcontrol/model';
import dictionaries from './dictionaries/model';
import operationInfo from './operation/model';
import sensitiveword from './sensitiveword/model';

export default [
    ...Object.values(operatingrule.sagas), // 运营规则
    ...Object.values(riderlevelset.sagas),//骑手等级
    ...Object.values(shippingfeeset.sagas),//配送费设置
    ...Object.values(parameter.sagas), // 参数设置
    ...Object.values(versions.sagas), // 版本管理
    ...Object.values(rate.sagas), //计费比例设置
    ...Object.values(feedbacktype.sagas), //反馈类型
    ...Object.values(financialset.sagas), //财务设置
    ...Object.values(riskcontrol.sagas), //风控管理
    ...Object.values(dictionaries.sagas), //攻略分类字典
    ...Object.values(operationInfo.sagas), //基本信息、财务信息、运营区域、资质信息
    ...Object.values(sensitiveword.sagas), //敏感词库
];